import deleteWithToken from './base/delete-with-token'

const userDelete = (id, data) => deleteWithToken(`/user/${id}`)(data)

export default userDelete